import React, { createContext, useContext, useState, useCallback } from "react";

interface SidebarSearchContextType {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

const SidebarSearchContext = createContext<SidebarSearchContextType | undefined>(undefined);

export const useSidebarSearch = () => {
  const context = useContext(SidebarSearchContext);
  if (context === undefined) {
    throw new Error("useSidebarSearch must be used within a SidebarSearchProvider");
  }
  return context;
};

interface SidebarSearchProviderProps {
  children: React.ReactNode;
}

export const SidebarSearchProvider = ({ children }: SidebarSearchProviderProps) => {
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <SidebarSearchContext.Provider value={{ searchQuery, setSearchQuery }}>
      {children}
    </SidebarSearchContext.Provider>
  );
};
